export const DEFAULT_ACCESS_LS_KEY = `da.user.${process.env.NEXT_PUBLIC_IDENTITY_CLIENT_ID}`;
export const CURRENT_ACCESS_SS_KEY = `ca.user.${process.env.NEXT_PUBLIC_IDENTITY_CLIENT_ID}`;

export const GET_USER_PERMISSIONS_ENDPOINT =
  'users/permissions/without-hierarchy';
